<template>
  <a @click="open"><slot /></a>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import appCan from 'bits/app_can'
import postMessage from 'native_bridge/post_message'
import { openLink } from 'native_bridge/actions'
import { buildUrlFromPath } from 'bits/location'

export default {
  props: {
    bridgeTarget: {
      type: String,
      default: 'external',
    },
  },
  methods: {
    open(event) {
      let url = this.$el.getAttribute('href')

      if (appCan('postMessage')) {
        event.preventDefault()
        // prepend host and protocol to links if they are not already there
        if (!/^https?:\/\//.test(url) && !/^\/\//.test(url)) {
          url = buildUrlFromPath(url)
        }
        postMessage(openLink(url, this.bridgeTarget))
        return false
      }
      return true
    },
  },
}
</script>
